export default "__VITE_ASSET__wqp0yz4k__"